import React from 'react';
import { Grid, List, ListItem, Typography, Box } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import { StyledLink } from '../../custom';

const DefaultFooter = () => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Grid item xs={6}>
        <Typography variant="body1" color="textSecondary">
          {t('legal')}
        </Typography>
        <List dense disablePadding aria-label="Small Businesses">
          <ListItem disableGutters>
            <StyledLink gatsbyLink to="/legal/terms-of-use">
              {t('termsOfUse')}
            </StyledLink>
          </ListItem>
          <ListItem disableGutters>
            <StyledLink gatsbyLink to="/legal/privacy-policy">
              {t('privacyPolicy')}
            </StyledLink>
          </ListItem>
          <ListItem disableGutters>
            <StyledLink gatsbyLink to="/legal/e-sign-consent">
              {t('eSignConsent')}
            </StyledLink>
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body1" color="textSecondary">
          {t('company')}
        </Typography>
        <List dense disablePadding aria-label="Small Businesses">
          <ListItem disableGutters>
            <StyledLink to="https://www.pintuna.com/about/">
              {t('aboutUs')}
            </StyledLink>
          </ListItem>
          <ListItem disableGutters>
            <StyledLink to="https://www.pintuna.com/faq/">FAQ</StyledLink>
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={12}>
        <Box pt={2}>
          <Typography variant="body1">© Pintuna Inc</Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DefaultFooter;
